import { ROLE_TYPES, ROLES_WITH_FIREWALL_RULES } from '@/common/constants/roles.constants';

function createNetworkRole(attributes) {
  if (!attributes?.name) {
    return null;
  }

  const {
    name = null,
    port = null,
    type = [ROLE_TYPES.ALL, ROLE_TYPES.CUSTOM, ROLE_TYPES.PREDEFINED].includes(attributes.type) ? attributes.type : null,
    exclusive = false,
    hidden = false,
    inbound_allow_list: inboundAllowList = null,
    inbound_deny_list: inboundDenyList = null,
  } = attributes;
  return {
    name,
    port,
    type,
    exclusive,
    hidden,
    hasFirewallRules:
      (type === ROLE_TYPES.PREDEFINED && ROLES_WITH_FIREWALL_RULES.includes(name))
      || type === ROLE_TYPES.CUSTOM,
    inboundAllowList,
    inboundAllowListString: inboundAllowList?.join(', '),
    inboundDenyList,
    inboundDenyListString: inboundDenyList?.join(', '),
  };
}

export default createNetworkRole;
